export default "__VITE_ASSET__CUEff$hx__"